import React, { useState } from 'react'
import { CiLink } from 'react-icons/ci'
import LinkModal from './LinkModal'
import Config from '../../Config/Config.json'

const TextAreaMovieAndOttNews = props => {
  const {
    inputReferencedescriptionEn,
    inputReferencedescriptionTe,
    movieAndOttNews,
    movieAndOttNewste,
    setMovieAndOttNews,
    setMovieAndOttNewste,
    // handleButtonClick,
    editIndex,
    sendOttToArray,
    saveEdit,
    link,
    setLink,
  } = props
  // const [link, setLink] = useState('')
  const [modalOpen, setModalOpen] = useState(false)
  const [currentDescription, setCurrentDescription] = useState('')
  const [isTextSelectedEn, setIsTextSelectedEn] = useState(false)
  const [isTextSelectedTe, setIsTextSelectedTe] = useState(false)
  const [selectedText, setSelectedText] = useState('')

  const handleButtonClick = description => {
    setCurrentDescription(description)
    setModalOpen(true)
  }

  const handleSelectionChange = (event, description) => {
    const textarea = event.target
    const { selectionStart } = textarea
    const { selectionEnd } = textarea

    // Update isTextSelected state based on whether text is selected
    // setIsTextSelected(selectionStart !== selectionEnd)
    if (description === 'description_En') {
      setIsTextSelectedEn(selectionStart !== selectionEnd)
    } else {
      setIsTextSelectedTe(selectionStart !== selectionEnd)
    }

    const selectedText = textarea.value.substring(selectionStart, selectionEnd).trim()
    setSelectedText(selectedText)
  }

  // const highlightSelectedText = description => {
  //   const textarea =
  //     description === 'description_En' ? inputReferencedescriptionEn.current : inputReferencedescriptionTe.current
  //   const startPos = textarea.selectionStart
  //   const endPos = textarea.selectionEnd

  //   const beforeText = movieAndOttNews.substring(0, startPos)
  //   const selectedText = movieAndOttNews.substring(startPos, endPos)
  //   const afterText = movieAndOttNews.substring(endPos)

  //   const highlightedText = `<span class="highlighted">${selectedText}</span>`
  //   const newText = beforeText + highlightedText + afterText

  //   if (description === 'description_En') {
  //     setMovieAndOttNews(newText)
  //   } else {
  //     setMovieAndOttNewste(newText)
  //   }
  // }

  const handleSaveLink = link => {
    const textarea =
      currentDescription === 'description_En'
        ? inputReferencedescriptionEn.current
        : inputReferencedescriptionTe.current

    if (textarea.selectionStart !== undefined && textarea.selectionEnd !== undefined) {
      const start = textarea.selectionStart
      const end = textarea.selectionEnd

      const selectedText =
        currentDescription === 'description_En'
          ? movieAndOttNews.substring(start, end)
          : movieAndOttNewste.substring(start, end)
      let updatedText = ''
      if (selectedText) {
        let baseUrl = ''
        if (Config.Environment === 'Production') {
          baseUrl = 'https://telugu.yousay.tv'
        } else if (Config.Environment === 'Development') {
          baseUrl = 'https://stagingyousay.ktree.org'
        } else {
          baseUrl = 'https://stagingyousay.ktree.org'
        }

        if (link.includes(baseUrl)) {
          const path = link.includes(`${baseUrl}/en/tfidb/`)
            ? `${baseUrl}/en/tfidb`
            : `${baseUrl}/tfidb`

          updatedText =
            currentDescription === 'Bio'
              ? `${movieAndOttNews.substring(0, start)}<a href='${link.replace(
                  path,
                  '',
                )}'>${selectedText}</a>${movieAndOttNews.substring(end)}`
              : `${movieAndOttNewste.substring(0, start)}<a href='${link.replace(
                  path,
                  '',
                )}'>${selectedText}</a>${movieAndOttNewste.substring(end)}`
        } else {
          updatedText =
            currentDescription === 'description_En'
              ? `${movieAndOttNews.substring(
                  0,
                  start,
                )}<a href='${link}' target='_blank'>${selectedText}</a>${movieAndOttNews.substring(
                  end,
                )}`
              : `${movieAndOttNewste.substring(
                  0,
                  start,
                )}<a href='${link}' target='_blank'>${selectedText}</a>${movieAndOttNewste.substring(
                  end,
                )}`
        }
      }
      //  else {
      //   updatedText = `${
      //     currentDescription === 'description_En'
      //       ? movieAndOttNews
      //       : movieAndOttNewste
      //   }<a href='${link}'></a>`
      // }

      if (updatedText) {
        if (currentDescription === 'description_En') {
          setMovieAndOttNews(updatedText)
        } else {
          setMovieAndOttNewste(updatedText)
        }
      }
    }
  }

  // const removeHighlight = () => {
  //   if (currentDescription === 'description_En') {
  //     setMovieAndOttNews(movieAndOttNews.replace('<span class="highlighted">', '').replace('</span>', ''))
  //   } else {
  //     setMovieAndOttNewste(movieAndOttNewste.replace('<span class="highlighted">', '').replace('</span>', ''))
  //   }
  // }

  // useEffect(() => {
  //   if (modalOpen) {
  //     highlightSelectedText(currentDescription)
  //   } else {
  //     removeHighlight()
  //   }
  // }, [modalOpen])

  // console.log(selectedText, 'selectedTextselectedText')
  return (
    <div className='movieOtt'>
      {['description_En', 'description_Te'].map((description, index) => (
        <div key={index} style={{ width: '100%' }}>
          <label>{description === 'description_En' ? 'description_En:' : 'description_Te:'}</label>
          <textarea
            className='rounded p-1'
            ref={
              description === 'description_En'
                ? inputReferencedescriptionEn
                : inputReferencedescriptionTe
            }
            value={description === 'description_En' ? movieAndOttNews : movieAndOttNewste}
            style={{ width: '90%', marginTop: '10px' }}
            rows={5}
            maxLength={450}
            onChange={event =>
              description === 'description_En'
                ? setMovieAndOttNews(event.target.value)
                : setMovieAndOttNewste(event.target.value)
            }
            onSelect={event => handleSelectionChange(event, description)}
          />
          <br />
          <button
            type='button'
            className='btn btn-primary'
            onClick={() => handleButtonClick(description)}
            disabled={description === 'description_En' ? !isTextSelectedEn : !isTextSelectedTe}
          >
            <CiLink />
          </button>
        </div>
      ))}
      <LinkModal
        isOpen={modalOpen}
        selectedText={selectedText}
        link={link}
        setLink={setLink}
        onClose={() => {
          setModalOpen(false)
          setIsTextSelectedEn(false)
          setIsTextSelectedTe(false)
          setSelectedText('')
          setLink('')
        }}
        onSave={link => {
          handleSaveLink(link)
          setLink('')
          setIsTextSelectedEn(false)
          setIsTextSelectedTe(false)
          setSelectedText('')
        }}
      />
      <div>
        {movieAndOttNews && movieAndOttNewste && (
          <button
            type='button'
            className='btn btn-primary'
            onClick={
              editIndex === null && movieAndOttNews && movieAndOttNewste ? sendOttToArray : saveEdit
            }
          >
            {editIndex === null ? 'Save' : 'Submit Edited'}
          </button>
        )}
      </div>
    </div>
  )
}

export default TextAreaMovieAndOttNews
